module.exports = __webpack_public_path__ + "static/media/calend.b1d62868.png";